export default {"src":"/_next/static/media/project-icon-without-logo.6ddbf8f3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};